import isNumeric from '@utilities/is-numeric'
import isAndroid from '@utilities/detect-os'

/**
 * Only a-z, A-Z and 0-9 are allowed keys
 *
 * @param enteredKey
 * @returns {boolean}
 * @constructor
 */
const IsBasicKey = function (enteredKey) {
  // When a keyCode was passed along
  if (
    (isNumeric(enteredKey) && enteredKey >= 48 && enteredKey <= 57) ||
    (enteredKey >= 65 && enteredKey <= 90) ||
    (isAndroid && enteredKey === 229)
  )
    return true

  // When a key was passed along
  if (/^[a-zA-Z0-9]{0,1}$/.test(enteredKey)) return true

  return false
}

export default IsBasicKey
